import Getdata from "./getdata";
import setDataLocal from "./setData";
export default function deleteItem(id_s) {
  let result = Getdata().filter(ele => ele.id != id_s);
  setDataLocal(false,result);
  return result;
}
